require('./contractPayrollLoanDocuments.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { withRouter } = require("react-router-dom");
// @core
const { FormattedText } = require('core/i18n').i18n;
// @components
const ContractPayrollLoanDocumentsUpload = require('../contractPayrollLoanDocuments/contractPayrollLoanDocumentsUpload/contractPayrollLoanDocumentsUpload');
const ContractPayrollLoanDocumentsButtons = require('../contractPayrollLoanDocuments/contractPayrollLoanDocumentsButtons/contractPayrollLoanDocumentsButtons');
const ContractPayrollLoanDocumentsLeaveModal = require('../contractPayrollLoanDocuments/contractPayrollLoanDocumentsLeaveModal/contractPayrollLoanDocumentsLeaveModal');
// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
//@utilities
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
//@constants
const {
    payrollLoanRecordStatus: { requestStatus: { ERROR_DOCUMENTACION } },
    payrollLoanTypeUpload: {
        IRPF_FILE,
        PAYROLL_LOAN_CERTIFICATE,
        ADITIONAL_EXPENSES_FILES
    }
} = require('../../../loansConstants/index');

class ContractPayrollLoanDocuments extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showPreLeaveModal: true
        };

        this.onClickFinishBtn = this.onClickFinishBtn.bind(this);
        this.onClickLeaveBtn = this.onClickLeaveBtn.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
    }

    componentDidMount() {
        const { initialize, simulationToken, getLoansForExpenses } = this.props;

        initialize(simulationToken);
        getLoansForExpenses(false);
    }

    handleConfirmLeave() {
        this.setState({
            showPreLeaveModal: false
        });
    }

    onClickFinishBtn() {
        this.props.finishBtn();

        if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
            this.setState({
                showPreLeaveModal: false
            },
                () => {
                    // IMPORTANT: The router redirection needs to be called in the callback after setState
                    // otherwise is not executed after the re-render caused by the state change
                    this.props.history.push('/myprofile/loans-mortgages');
                });
        }
    }

    onClickLeaveBtn() {
        this.props.history.push('/myprofile/loans-mortgages');
    }

    isFinishButtonDisabled() {
        const { recordStatus, immPayrollLoanRequest } = this.props;
        const immUpload = immPayrollLoanRequest.get('upload');

        if (recordStatus === ERROR_DOCUMENTACION) {
            const immFiles = immUpload.getIn([ADITIONAL_EXPENSES_FILES, 'files']);

            if (immUpload.getIn([IRPF_FILE, 'notValid'])) {
                return true;
            }

            if (immUpload.getIn([PAYROLL_LOAN_CERTIFICATE, 'notValid'])) {
                return true;
            }

            let invalidFile = false;
            immFiles.forEach(immFile => {
                if (immFile.get('documentId') !== null && immFile.get('notValid')) {
                    invalidFile = true;
                    return false;
                }
            });

            return invalidFile;
        }

        return false;
    }

    builDisclaimerText() {
        return (
            <div className="payroll-loan-request-documents__superscript-info">
                <FormattedText
                    value="contractEasyLoanStepOne-contractEasyLoanStepOne_superscriptInfo"
                />
            </div>
        )
    }

    render() {
        const {
            clearErrorsFile,
            compilationCard,
            dropRecord,
            handlerEditFileName,
            immPayrollLoanRequest,
            initialized,
            isFetchingLoans,
            loadFileInUpload,
            recordStatus,
            removeUploadedFile,
        } = this.props;
        const immUpload = immPayrollLoanRequest.get('upload');
        const isFetching = immUpload.get('isFetching') || immUpload.get('isFetchingDocumentsConfirm') ||
            immUpload.get('isLoadingFiles') || isFetchingLoans;
        const finishButtonDisabled = this.isFinishButtonDisabled();
        const disclaimerText = this.builDisclaimerText();

        return initialized ? (
            <div className="payroll-loan-request-documents" id="printable-wizard">

                <div className="col-xs-8">
                    <article className="payroll-loan-request-documents__box">
                        <ContractPayrollLoanDocumentsUpload
                            immPayrollLoanRequest={immPayrollLoanRequest}
                            loadFileInUpload={loadFileInUpload}
                            clearErrorsFile={clearErrorsFile}
                            removeUploadedFile={removeUploadedFile}
                            recordStatus={recordStatus}
                            handlerEditFileName={handlerEditFileName}
                        />
                        <ContractPayrollLoanDocumentsButtons
                            finishButtonDisabled={finishButtonDisabled}
                            handleFinishBtn={this.onClickFinishBtn}
                            handleLeaveBtn={this.onClickLeaveBtn}
                            loading={isFetching}
                            recordStatus={recordStatus}
                        />
                    </article>
                    {disclaimerText}
                </div>
                {compilationCard}
                {this.state.showPreLeaveModal &&
                    <ContractPayrollLoanDocumentsLeaveModal
                        dropRecord={dropRecord}
                        onConfirmLeave={this.handleConfirmLeave}
                    />
                }
            </div>
        ) :
            (
                <LoadingSection />
            );
    }
}

ContractPayrollLoanDocuments.propTypes = {
    handlerEditFileName: PropTypes.func.isRequired,
    immPayrollLoanRequest: PropTypes.object.isRequired,
    initialize: PropTypes.func.isRequired,
    initialized: PropTypes.bool.isRequired,
    isFetchingLoans: PropTypes.bool.isRequired,
    loadFileInUpload: PropTypes.func,
    getLoansForExpenses: PropTypes.func.isRequired,
    clearErrorsFile: PropTypes.func.isRequired,
    removeUploadedFile: PropTypes.func.isRequired,
    finishBtn: PropTypes.func,
    compilationCard: PropTypes.object,
    dropRecord: PropTypes.func.isRequired,
    recordStatus: PropTypes.string.isRequired,
    simulationToken: PropTypes.string,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(ContractPayrollLoanDocuments);
